<template>
  <v-dialog persistent v-model="editDialog.status" max-width="300px">
    <v-card>
      <v-card-title class="overline">
        Edit Player
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col md="6">
            <v-switch v-model="editDialog.item.leader" label="隊長" style="margin: 8px;max-height: 5px"></v-switch>
          </v-col>
          <v-col md="6">
            <v-select v-model="editDialog.item.class" :items="editDialog.classes" label="Player Class"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined color="grey" @click="editDialog.status = false">Cancel</v-btn>
        <v-btn outlined color="primary" @click="updatedPlayer">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const firebase = require('firebase')
const database = firebase.database()
export default {
  name: 'editDialog',
  data: () => ({
    editDialog: {}
  }),
  created () {
    this.editDialog = this.$store.state.editDialog
  },
  methods: {
    updatedPlayer () {
      let result = this.$store.state.joinCard.players.filter(player => this.editDialog.item.name === player.name)
      result[0].class = this.editDialog.item.class
      result[0].leader = this.editDialog.item.leader
      // database.ref('/game_record/' + this.$store.state.joinCard.groupKey + '/players').set(this.$store.state.joinCard.players)
      this.editDialog.status = false
      this.$store.commit('setSnackBar', {
        icon: 'far fa-check-circle',
        color: 'primary',
        status: true,
        text: 'Player Record Edited',
        timeout: 2000
      })
    }
  }
}
</script>

<style scoped>

</style>
